import { useSetAtom } from 'jotai';
import { DTOProfileCardType } from 'src/apis/dto/DTOProfileCard';
import ReportAndBlockPopup from 'src/components/ReportAndBlockPopup';
import { showModalAtom } from 'src/stores/modal/atoms';
import { EVENT_NAME, EVENT_TYPE } from 'src/types/Event';
import { ModalType } from 'src/types/Modal';
import { pushEvent } from 'src/utils/event-gateway';
import { useProfileCardContext } from '.';
export const useReportAndBlock = ({
  target
}: {
  target: 'icon' | 'text';
}) => {
  const showModal = useSetAtom(showModalAtom);
  const {
    profile,
    eventTab,
    eventSection,
    onReportSuccess
  } = useProfileCardContext();
  const canReport = profile.type !== 'MY_PROFILE' && profile.type !== 'MATCH';
  const handleClickReportOrBlock = () => {
    if (!canReport) return;
    if (!profile.id || !profile.profileImageInfos) {
      console.error('[Report] Invalid profile data', {
        profileType: profile.type,
        hasId: !!profile.id,
        hasImages: !!profile.profileImageInfos
      });
      return;
    }
    const cardType = profile.type;
    const eventParams = {
      tab: eventTab ?? 'anywhere',
      page: 'profile',
      section: eventSection ?? 'none',
      target,
      target_id: 'card_id',
      target_detail: profile.id
    };
    pushEvent({
      eventType: EVENT_TYPE.REPORT,
      eventName: EVENT_NAME.REPORT_BLOCK_CLICK,
      eventParams: {
        ...eventParams,
        action_category: 'click'
      }
    });
    showModal({
      key: ModalType.REPORT_AND_BLOCK_POPUP,
      component: () => <ReportAndBlockPopup cardId={profile.id} cardType={cardType as Exclude<DTOProfileCardType, 'MATCH'>} visibleProfileImageOption={profile.profileImageInfos?.length > 0} eventParams={eventParams} onSuccess={onReportSuccess} />
    });
  };
  return {
    canReport,
    handleClickReportOrBlock
  };
};